import { push } from 'connected-react-router';
import api from '../../api';

export const authenticationsStartRequest = () => {
  return {
    type: 'AUTHENTICATIONS_START_REQUEST'
  };
};

export const authenticationsEndRequest = () => {
  return {
    type: 'AUTHENTICATIONS_END_REQUEST'
  };
};

export const authenticationsLoginSuccess = ({ data }) => {
  return {
    type: 'AUTHENTICATIONS_LOGIN_SUCCESS',
    payload: data
  };
};

export const authenticationsLoginError = error => {
  return {
    type: 'AUTHENTICATIONS_LOGIN_ERROR',
    payload: error
  };
};

export const authenticationsLogoutSuccess = ({ data }) => {
  return {
    type: 'AUTHENTICATIONS_LOGOUT_SUCCESS',
    payload: data
  };
};

export const authenticationsLogoutError = error => {
  return {
    type: 'AUTHENTICATIONS_LOGOUT_ERROR',
    payload: error
  };
};

export const authenticationsCheckSession = data => {
  return {
    type: 'AUTHENTICATIONS_UPDATE_SESSION',
    payload: data
  };
};

export const authenticate = (data, formReset, submitBtn) => {
  return async dispatch => {
    try {
      submitBtn.disabled = true;
      dispatch(authenticationsStartRequest());
      const response = await api().post('/api/auth/login', data);
      dispatch(authenticationsLoginSuccess(response));
      dispatch(authenticationsEndRequest());
      formReset();
      submitBtn.disabled = false;
      dispatch(push('/dashboard'));
    } catch (err) {
      dispatch(authenticationsLoginError(err));
      dispatch(authenticationsEndRequest());
      submitBtn.disabled = false;
    }
  };
};

export const leave = (data = {}, submitBtn = {}) => {
  return async dispatch => {
    try {
      submitBtn.disabled = true;
      dispatch(authenticationsStartRequest());
      const response = await api().post('/api/auth/logout', data);
      dispatch(authenticationsLogoutSuccess(response));
    } catch (err) {
      dispatch(authenticationsLogoutError(err));
    } finally {
      submitBtn.disabled = false;
      dispatch(authenticationsEndRequest());
      dispatch(push('/'));
    }
  };
};
